import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthentificationService } from '@app/common-codes/services/authentification.service';

@Component({
  selector: 'app-unauthorize',
  standalone: false,
  templateUrl: './unauthorized.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './unauthorized.component.css'
})
export class UnauthorizedComponent {

  constructor(
    public authentificationService: AuthentificationService
  ) { }

}
